






import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { checkIfAuthenticated } from "@/services/security/authService";

const namespace: string = "authentication";

@Component
export default class AutoLogout extends Vue {
    @Getter("getAutologout", { namespace }) autologout: any;

    @Watch("autologout", { immediate: true, deep: true })
    onActiveChange(value: boolean) {
        if (value) {
            this.showWarning();
        }
        if (!value) {
            this.hideWarning();
        }
    }

    // actions
    showWarning() {
        this.$bvModal.show("modal-autoLogout");
    }

    hideWarning() {
        this.$bvModal.hide("modal-autoLogout");
    }

    confirmActive() {
        this.hideWarning();
        checkIfAuthenticated();
    }
}
